import React from 'react';
import Navbar from '../component/Navbar/Navbar';
import LandingPage from '../component/LandingPage/LandingPage';
import Faq from '../component/Faq/Faq';
import Footer from '../component/Footer/Footer';
import PrimaryFeature from '../component/PrimaryFeature/PrimaryFeature';
import SecondaryFeature from '../component/SecondaryFeature/SecondaryFeature';
import Testimonials from '../component/Testimonials/Testimonials';
import Advertising from '../component/Advertising/Advertising';

function Home() {
  return (
    <div className="Home">
      <Navbar />
      <div className="seam-bridge" aria-hidden="true">
        <LandingPage />
        <Advertising />
      </div>
      <div className="after-bg">
        <PrimaryFeature />
        <SecondaryFeature />
        {/* <VibeMarketting/> */}
        <Testimonials />
        {/* <Countdown/> */}
        <Faq />
        <Footer />
      </div>
    </div>
  );
}

export default Home;
